import css from './index.module.scss';
import { useGlobal } from '@/utils/useGlobal';

export default function FixTab() {
    const { useLang, useState, useEffect } = useGlobal();
    const { t } = useLang('loadshedding');
    const [activeTab, setActiveTab] = useState(0);
    const [winW, setWinW] = useState(1920);
    const tabs: any = [
        { text: t('fix_tab1'), id: '#load-shedding-B', key: 0 },
        { text: t('fix_tab2'), id: '#load-shedding-C', key: 1 },
        { text: t('fix_tab3'), id: '#load-shedding-O', key: 2 },
        { text: t('fix_tab4'), id: '#load-shedding-P', key: 3 },
        { text: t('fix_tab5'), id: '#load-shedding-Q', key: 4 },
    ];
    const handleClickTab = (k: number) => {
        setActiveTab(k);
    };

    let originX = 0,
        startX = 0;
    const onTouchStart = (e: any) => {
        originX = parseFloat(e.currentTarget?.style.left) || 0;
        startX = e.targetTouches[0]?.clientX;
    };

    const onTouchMove = (e: any) => {
        const moveX = e.targetTouches[0]?.clientX;
        const endX = originX + moveX - startX;
        if (endX <= 0 && endX >= window.innerWidth - e.currentTarget.offsetWidth) {
            e.currentTarget.style.left = `${endX}px`;
        }
    };

    useEffect(() => {
        if (typeof window !== 'undefined') {
            setWinW(window.innerWidth);
            const resizeFunc = () => {
                const target = document.querySelector('.load-shedding-fix-tab .tabs-box') as HTMLUListElement;
                target.style.transition = 'left .4s ease';
                if (target.offsetWidth > window.innerWidth && activeTab >= 3) {
                    target.style.left = `${window.innerWidth - target.offsetWidth}px`;
                } else {
                    target.style.left = `${0}px`;
                }
            };
            resizeFunc();
            window.addEventListener('resize', resizeFunc);
            return () => window.removeEventListener('resize', resizeFunc);
        }
    }, [activeTab]);

    useEffect(() => {
        const scrollFunc = (id: string, k: number) => {
            const target = document.querySelector(id) as HTMLDivElement;

            AniContainer.create({
                triggerElement: id,
                triggerHook: 1,
                offset: '50%',
                duration: target?.offsetHeight,
                onEnter: () => setActiveTab(k),
            });
        };

        const ids: string[] = ['#load-shedding-C', '#load-shedding-J', '#load-shedding-P', '#load-shedding-Q', '#load-shedding-R'];
        ids.forEach((id: string, k: number) => scrollFunc(id, k));

        AniContainer.create({
            triggerElement: '#load-shedding-R',
            triggerHook: 1,
            offset: '50%',
            onEnter: () => setActiveTab(5),
        });
    }, []);

    return (
        <div className={`load-shedding-fix-tab ${css['load-shedding-fix-tab']}`}>
            <div className="tabs-wrapper">
                <ul className="tabs-box" onTouchStart={onTouchStart} onTouchMove={onTouchMove}>
                    {tabs?.map((tab: any, k: number) => (
                        <a className={`tab ${activeTab === k ? 'active' : ''}`} href={tab?.id} key={tab?.id} onClick={() => handleClickTab(tab?.key)}>
                            {tab?.text}
                        </a>
                    ))}
                </ul>
            </div>
        </div>
    );
}
